import { useEffect, useState } from "react";
import ReactSpeedometer, { CustomSegmentLabelPosition } from "react-d3-speedometer";
import { ambienteInternoPontoForteService } from "../../services/AmbienteInternoPontoForteService";
import { ambienteInternoPontoFracoService } from "../../services/AmbienteInternoPontoFracoService";
import { ambienteExternoService } from "../../services/AmbienteExternoService";
import { AMEACA, OPORTUNIDADE } from "../../types/constants/ClassificacaoAmbienteExterno";
import { normalize } from "../../utils/string";
import { AmbienteExterno } from "../../types/negocio/AmbienteExterno";
import { AmbienteInternoPontoForte } from "../../types/negocio/AmbienteInternoPontoForte";
import { AmbienteInternoPontoFraco } from "../../types/negocio/AmbienteInternoPontoFraco";

function calcularIndiceFavorabilidade(
    pontosFortesPontuacaoTotal: number,
    pontosFracosPontuacaoTotal: number,
    oportunidadesPontuacaoTotal: number,
    ameacasPontuacaoTotal: number
): number {
    const fatorPositivo = pontosFortesPontuacaoTotal + oportunidadesPontuacaoTotal;
    const fatorNegativo = pontosFracosPontuacaoTotal + ameacasPontuacaoTotal;
    const total = fatorPositivo + fatorNegativo;
    
    // Se não houver dados, retorna 50 (neutro)
    if (total === 0) return 50;
    
    // Calcula o percentual de favorabilidade (0-100%)
    // Quanto maior a proporção de fatores positivos, maior o índice
    return (fatorPositivo / total) * 100;
}

export default function IndiceFavorabilidade() {

    const [indiceFavorabilidade, setIndiceFavorabilidade] = useState(0);

    useEffect(() => {
        var promises = [];
        let pontosFortes: AmbienteInternoPontoForte[] = [];
        let pontosFracos: AmbienteInternoPontoFraco[] = [];
        let oportunidades: AmbienteExterno[] = [];
        let ameacas:AmbienteExterno[] = [];
        promises.push(ambienteInternoPontoForteService.listarTodos().then((response) => pontosFortes = response));
        promises.push(ambienteInternoPontoFracoService.listarTodos().then((response) => pontosFracos = response));
        promises.push(ambienteExternoService.listarTodos().then((response) => {
            oportunidades = response.filter((item) => normalize(item.fator) === OPORTUNIDADE);
            ameacas = response.filter((item) => normalize(item.fator) === AMEACA);
        }));
        Promise.all(promises).then(() => {
            const pontosFortesPontuacaoTotal = pontosFortes.reduce((acc, e) => acc + e.pontuacao, 0);
            const pontosFracosPontuacaoTotal = pontosFracos.reduce((acc, e) => acc + e.pontuacao, 0);
            const oportunidadesPontuacaoTotal = oportunidades.reduce((acc, e) => acc + e.pontuacao, 0);
            const ameacasPontuacaoTotal = ameacas.reduce((acc, e) => acc + e.pontuacao, 0);

            const indice = calcularIndiceFavorabilidade(
                pontosFortesPontuacaoTotal,
                pontosFracosPontuacaoTotal,
                oportunidadesPontuacaoTotal,
                ameacasPontuacaoTotal
            );
            setIndiceFavorabilidade(indice);

        }).catch((error) => {
            console.error("Erro ao calcular o índice de favorabilidade:", error);
        });

    }, []);
    // Define the CSS for the custom segment labels


    return (
        <ReactSpeedometer
            width={500}
            minValue={0}
            maxValue={100}
            value={indiceFavorabilidade}
            segments={5}
            customSegmentStops={[0, 20, 40, 60, 80, 100]}
            customSegmentLabels={[
                {
                    text: "Crítico",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#fff",
                    fontSize: "14px",
                },
                {
                    text: "Desfavorável",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#fff",
                    fontSize: "14px",
                },
                {
                    text: "Neutro",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#555",
                    fontSize: "14px",
                },
                {
                    text: "Favorável",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#555",
                    fontSize: "14px",
                },
                {
                    text: "Excelente",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#555",
                    fontSize: "14px",
                }
            ]}
            segmentColors={["#FF0000", "#FF6B00", "#FFEB3B", "#8BC34A", "#4CAF50"]}
            needleColor="black"
            valueFormat="d"
            currentValueText="Índice: ${value}%"
            valueTextFontSize="26px"
            height={300}
        />);

}

